import React from 'react';
import {
	Container,
	ContainerButtons,
	ContainerPermissionButtons,
	ContainerScheduleButtons,
	Icon,
} from './Candidates.styles';

import { Button } from '@welbe/design-system';

import { tokens } from 'styles/tokens';

import { ReactComponent as InformationIcon } from 'App/assets/img/information.svg';
import { FiCalendar } from 'react-icons/fi';

type CandidatesButtonsProps = {
	handleShowModalApproveCandidate: () => void;
	handleShowModalRejectCandidate: () => void;
	onEditAppointment: () => void;
	hasJustPendentAtRHStatus?: boolean;
	amountCandidates?: number;
	hasJustPendentAtDoctorStatus?: boolean;
};

export const CandidatesButtons = ({
	handleShowModalApproveCandidate,
	handleShowModalRejectCandidate,
	onEditAppointment,
	amountCandidates,
	hasJustPendentAtRHStatus,
	hasJustPendentAtDoctorStatus,
}: CandidatesButtonsProps): JSX.Element => {
	return (
		<Container>
			<ContainerButtons>
				<ContainerPermissionButtons>
					<Button
						onClick={handleShowModalApproveCandidate}
						backgroundColor={tokens.color_secondary}
						disabled={!hasJustPendentAtRHStatus}
						width={'100px'}
					>
						Aprobar
					</Button>
					<Button
						onClick={handleShowModalRejectCandidate}
						colorPalette="red"
						disabled={!hasJustPendentAtRHStatus}
						width={'100px'}
					>
						Declinar
					</Button>
					<Icon>
						<span
							className="hoverText hoverTextRight"
							data-hover="Estatus RH permitido para las acciones: Pendiente"
						>
							<InformationIcon width={25} />
						</span>
					</Icon>
				</ContainerPermissionButtons>
				<ContainerScheduleButtons>
					<Button
						onClick={onEditAppointment}
						backgroundColor={tokens.color_primary}
						disabled={
							Boolean(amountCandidates && amountCandidates > 1) ||
							!hasJustPendentAtDoctorStatus ||
							!hasJustPendentAtRHStatus
						}
						width="200px"
					>
						<p>Citas médicas</p>
						<FiCalendar />
					</Button>
					<Icon>
						<span
							className="hoverText hoverTextLeft"
							data-hover={
								amountCandidates && amountCandidates > 1
									? 'Sólo se puede editar la cita de un paciente a la vez'
									: 'Estatus médico permitidos para la acción: Pendiente/Cita solicitada'
							}
						>
							<InformationIcon width={25} />
						</span>
					</Icon>
				</ContainerScheduleButtons>
			</ContainerButtons>
		</Container>
	);
};
